import styled from 'styled-components';
import { color, font, breakpoint } from 'styles/globals';

export const Container = styled.div`
    @media (${breakpoint.lgMin}) {
        padding: 0  24px;
  }
`;

export const List = styled.ul`
    font-family: ${font.graphikCond};
    font-weight: 600;
    letter-spacing: .5px;
    margin-top: 16px;
`;

export const ListItem = styled.li`
    align-items: center;
    display: flex;
    color: ${color.accentPrimary};
    margin-bottom: 16px;

    &:last-of-type {
        margin-bottom: 0;
    }

    a {
        color: inherit;
    }
    
    .next-arrow {
        border-color: ${color.accentPrimary};
        transform: scale(.75) translateX(-6px);
    }
`;
